<div class="modal">
  <div class="modal-overlay" (click)="cancelAsync()"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <i class="ms-3 bi bi-person"></i>
        <span class="ms-1 modal-title" i18n="@@UserLoginCustomerSelectDialogHeading">Select customer</span>
        <span class="me-auto"></span>
      </div>

      <div class="modal-body">
        <div class="form-floating m-2">
          <select #customerSelect class="form-select" [(ngModel)]="customerSelected" required name="userLoginSelectCustomerDialogCustomerUserInput">
            @for (customer of customerList; track customer) {
              <option [ngValue]="customer">{{ customer | customerNamesToString }}</option>
            }
          </select>
          <label for="userLoginSelectCustomerDialogCustomerUserInput" i18n="@@UserLoginCustomerSelectDialogCustomerLabel">Customer</label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="customerSelectAsync(customerSelected)" [disabled]="customerSelected == undefined" i18n="@@UserLoginCustomerSelectDialogConfirmButton">Select</button>
        <button class="btn btn-link" (click)="cancelAsync()" i18n="@@UserLoginCustomerSelectDialogCancelButton">Cancel</button>
      </div>
    </div>
  </div>
</div>
